var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFloorPlansIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 1.3335L11.5 3.8335V14.6668L16.5 12.1668V1.3335Z",
    fill: "#572148"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 1.3335L1.5 3.8335V14.6668L6.5 12.1668V1.3335Z",
    fill: "#572148"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 1.3335L1.5 3.8335V14.6668L6.5 12.1668M6.5 1.3335L11.5 3.8335M6.5 1.3335V12.1668M11.5 3.8335L16.5 1.3335V12.1668L11.5 14.6668M11.5 3.8335V14.6668M11.5 14.6668L6.5 12.1668",
    stroke: "#572148",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloorPlansIcon);
export default __webpack_public_path__ + "static/media/FloorPlans-icon.e6dbba5a060f510c9def488ef321ba62.svg";
export { ForwardRef as ReactComponent };